import api from './api';

export interface PackagingRequestItem {
  readonly widthIn: number;
  readonly heightIn: number;
  readonly galleryWrapIn?: number;
  readonly quantity?: number;
  readonly gsm?: number;
  readonly paperTypeId?: string;
}

export interface PackagingComputeRequest {
  readonly items: ReadonlyArray<PackagingRequestItem>;
}

export interface PackagingDimensions {
  readonly lengthIn: number;
  readonly widthIn: number;
  readonly heightIn: number;
}

export interface PackagingComputeResponse {
  readonly packagingType: 'box' | 'tube' | 'custom';
  readonly packagingSku: string | null;
  readonly packagingCostUSD: number | null;
  readonly packagingWeightGrams: number;
  readonly itemsWeightGrams: number;
  readonly totalWeightGrams: number;
  readonly packageDimensions: PackagingDimensions;
}

export const computePackaging = async (
  payload: PackagingComputeRequest,
): Promise<PackagingComputeResponse> => {
  const { data } = await api.post<{ data: PackagingComputeResponse }>('/packaging/compute', payload);
  return data.data;
};
